/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UploadControllerGetChangesToValidateResponse,
  UploadServiceCreateUploadFileResponse,
} from '../models/index';
import {
    UploadControllerGetChangesToValidateResponseFromJSON,
    UploadControllerGetChangesToValidateResponseToJSON,
    UploadServiceCreateUploadFileResponseFromJSON,
    UploadServiceCreateUploadFileResponseToJSON,
} from '../models/index';

export interface UploadApiApiUploadApplyChangesPostRequest {
    timePeriodDate?: Date;
}

export interface UploadApiApiUploadCreateUploadFilePostRequest {
    file?: Blob;
    timePeriodDate?: Date;
}

export interface UploadApiApiUploadDeclineUploadFilePostRequest {
    uploadId?: string;
}

export interface UploadApiApiUploadGetChangesToValidateGetRequest {
    timePeriodDate?: Date;
}

/**
 * 
 */
export class UploadApi extends runtime.BaseAPI {

    /**
     */
    async apiUploadApplyChangesPostRaw(requestParameters: UploadApiApiUploadApplyChangesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }


        let urlPath = `/api/Upload/ApplyChanges`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiUploadApplyChangesPost(requestParameters: UploadApiApiUploadApplyChangesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.apiUploadApplyChangesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUploadCreateUploadFilePostRaw(requestParameters: UploadApiApiUploadCreateUploadFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadServiceCreateUploadFileResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }


        let urlPath = `/api/Upload/CreateUploadFile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadServiceCreateUploadFileResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUploadCreateUploadFilePost(requestParameters: UploadApiApiUploadCreateUploadFilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadServiceCreateUploadFileResponse> {
        const response = await this.apiUploadCreateUploadFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUploadDeclineUploadFilePostRaw(requestParameters: UploadApiApiUploadDeclineUploadFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['uploadId'] != null) {
            formParams.append('UploadId', requestParameters['uploadId'] as any);
        }


        let urlPath = `/api/Upload/DeclineUploadFile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiUploadDeclineUploadFilePost(requestParameters: UploadApiApiUploadDeclineUploadFilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.apiUploadDeclineUploadFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUploadGetChangesToValidateGetRaw(requestParameters: UploadApiApiUploadGetChangesToValidateGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadControllerGetChangesToValidateResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/Upload/GetChangesToValidate`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadControllerGetChangesToValidateResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUploadGetChangesToValidateGet(requestParameters: UploadApiApiUploadGetChangesToValidateGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadControllerGetChangesToValidateResponse> {
        const response = await this.apiUploadGetChangesToValidateGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
